// // GetInTouchForm.js
// import React, { useState } from "react";
// import { Modal, Form, Row, Col } from "react-bootstrap";
// import { useFormik } from "formik";
// import { useNavigate } from "react-router-dom";
// import Button from "../Button/Button";
// // import "./GetInTouchHome.css";
// import * as Yup from "yup";

// const GetInTouchForm = ({ showModal, handleClose }) => {
//   const navigate = useNavigate();

//   const formik = useFormik({
//     initialValues: {
//       firstName: "",
//       lastName: "",
//       email: "",
//       companyName: "",
//       message: "",
//       privacyPolicy: false,
//     },
//     validationSchema: Yup.object({
//       firstName: Yup.string().required("First Name is required"),
//       lastName: Yup.string().required("Last Name is required"),
//       email: Yup.string()
//         .email("Invalid email address")
//         .required("Email is required"),
//       companyName: Yup.string().required("Company Name is required"),
//       message: Yup.string().required("Message is required"),
//     }),
//     onSubmit: async (values, { resetForm }) => {
//       try {
//         const apiUrl = `${process.env.REACT_APP_NEWSLETTER_API_URL}/demo-email`;

//         const ipResponse = await fetch("https://api64.ipify.org?format=json");
//         const ipData = await ipResponse.json();
//         const userIp = ipData.ip;

//         const formData = new FormData();
//         formData.append("to", "Cync-Website-Lead@cyncsoftware.com");
//         formData.append("firstName", values.firstName);
//         formData.append("lastName", values.lastName);
//         formData.append("email", values.email);
//         formData.append("companyName", values.companyName);
//         formData.append("message", values.message);
//         formData.append("ip", userIp);

//         const response = await fetch(apiUrl, {
//           method: "POST",
//           headers: {
//             "x-api-key": process.env.REACT_APP_X_API_KEY,
//           },
//           body: formData,
//         });

//         if (response.ok) {
//           navigate("/contact/thank-you");
//           resetForm();
//         } else {
//           console.error("Error sending email");
//         }
//       } catch (error) {
//         console.error("Error sending email", error);
//       }
//     },
//   });

//   return (
//     <Modal show={showModal} onHide={handleClose} centered>
//       <Modal.Header closeButton>
//         <Modal.Title>Get in Touch</Modal.Title>
//       </Modal.Header>
//       <Modal.Body>
//         <form className="d-flex flex-column" onSubmit={formik.handleSubmit}>
//           <Col className="input-tag  my-2 border">
//             <input
//               className="w-100 bg-white py-2 px-3 border-0"
//               type="text"
//               placeholder="First Name*"
//               {...formik.getFieldProps("firstName")}
//             />
//             {formik.touched.firstName && formik.errors.firstName && (
//               <div className="text-danger">{formik.errors.firstName}</div>
//             )}
//           </Col>
//           <Col className=" input-tag  my-2 border">
//             <input
//               className="w-100 bg-white py-2 px-3 border-0"
//               type="text"
//               placeholder="last Name*"
//               {...formik.getFieldProps("lastName")}
//             />
//             {formik.touched.lastName && formik.errors.lastName && (
//               <div className="text-danger">{formik.errors.lastName}</div>
//             )}
//           </Col>
//           <Col className="input-tag  my-2 border">
//             <input
//               className="w-100 bg-white py-2 px-3 border-0"
//               type="text"
//               placeholder="email*"
//               {...formik.getFieldProps("email")}
//             />
//             {formik.touched.email && formik.errors.email && (
//               <div className="text-danger">{formik.errors.email}</div>
//             )}
//           </Col>
//           <Col className="input-tag  my-2 border">
//             <input
//               className="w-100 bg-white py-2 px-3 border-0"
//               type="text"
//               placeholder="Company Name*"
//               {...formik.getFieldProps("companyName")}
//             />
//             {formik.touched.companyName && formik.errors.companyName && (
//               <div className="text-danger">{formik.errors.companyName}</div>
//             )}
//           </Col>
//           <Col className="input-tag-message my-2 border">
//             <textarea
//               className="w-100 bg-white py-2 px-3 border-0"
//               placeholder="message"
//               {...formik.getFieldProps("message")}
//             />
//             {formik.touched.message && formik.errors.message && (
//               <div className="text-danger">{formik.errors.message}</div>
//             )}
//           </Col>
//           <Button type="submit" className="button career-submit mt-5">
//             Submit
//           </Button>
//         </form>
//       </Modal.Body>
//     </Modal>
//   );
// };

// export default GetInTouchForm;
import React, { useState } from "react";
import { Modal, Form, Row, Col } from "react-bootstrap";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";
import Button from "../Button/Button";
import * as Yup from "yup";

const GetInTouchForm = ({ showModal, handleClose }) => {
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      companyName: "",
      message: "",
      privacyPolicy: false,
    },
    validationSchema: Yup.object({
      firstName: Yup.string().required("First Name is required"),
      lastName: Yup.string().required("Last Name is required"),
      email: Yup.string()
        .email("Invalid email address")
        .required("Email is required"),
      companyName: Yup.string().required("Company Name is required"),
      message: Yup.string().required("Message is required"),
    }),
    onSubmit: async (values, { resetForm }) => {
      try {
        const apiUrl = `${process.env.REACT_APP_NEWSLETTER_API_URL}/get-email`;

        // const apiUrl = `http://localhost:5000/get-email`;

        const ipResponse = await fetch("https://api64.ipify.org?format=json");
        const ipData = await ipResponse.json();
        const userIp = ipData.ip;

        const formData = {
          to: "inquiry@idexcel.com",
          firstName: values.firstName,
          lastName: values.lastName,
          email: values.email,
          companyName: values.companyName,
          message: values.message,
          ip: userIp,
          service: window.location.pathname,
        };

        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // "x-api-key": process.env.REACT_APP_X_API_KEY,
          },
          body: JSON.stringify(formData),
        });

        if (response.ok) {
          navigate("/thank-you");
          resetForm();
        } else {
          console.error("Error sending email");
          resetForm();
        }
      } catch (error) {
        console.error("Error sending email", error);
        resetForm();
      }
    },
  });

  return (
    <Modal show={showModal} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Get in Touch</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form className="d-flex flex-column" onSubmit={formik.handleSubmit}>
          <Col className="input-tag my-2 border">
            <input
              className="w-100 bg-white py-2 px-3 border-0"
              type="text"
              placeholder="First Name*"
              {...formik.getFieldProps("firstName")}
            />
          </Col>
          {formik.touched.firstName && formik.errors.firstName && (
            <div className="text-danger">{formik.errors.firstName}</div>
          )}
          <Col className="input-tag my-2 border">
            <input
              className="w-100 bg-white py-2 px-3 border-0"
              type="text"
              placeholder="Last Name*"
              {...formik.getFieldProps("lastName")}
            />
          </Col>
          {formik.touched.lastName && formik.errors.lastName && (
            <div className="text-danger">{formik.errors.lastName}</div>
          )}
          <Col className="input-tag my-2 border">
            <input
              className="w-100 bg-white py-2 px-3 border-0"
              type="text"
              placeholder="Email*"
              {...formik.getFieldProps("email")}
            />
          </Col>
          {formik.touched.email && formik.errors.email && (
            <div className="text-danger">{formik.errors.email}</div>
          )}
          <Col className="input-tag my-2 border">
            <input
              className="w-100 bg-white py-2 px-3 border-0"
              type="text"
              placeholder="Company Name*"
              {...formik.getFieldProps("companyName")}
            />
          </Col>
          {formik.touched.companyName && formik.errors.companyName && (
            <div className="text-danger">{formik.errors.companyName}</div>
          )}
          <Col className="input-tag-message my-2 border">
            <textarea
              className="w-100 bg-white py-2 px-3 border-0"
              placeholder="Message"
              {...formik.getFieldProps("message")}
            />
          </Col>

          <Button
            type="submit"
            className="button career-submit mt-5"
            disabled={formik.isSubmitting}
          >
            {formik.isSubmitting ? "Submitting..." : "Submit"}
          </Button>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default GetInTouchForm;
